module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTg3MTUyYmU4NmZkMTJhOGVkNDZiMTk4MDNlYzljYzUucG5nIjs="